import React from 'react';
import { motion } from 'framer-motion';

import { OPEN_MENU_ANIMATION_DURATION_OUT, OPEN_MENU_ANIMATION_EASE_OUT } from '../../../config/constants';

export interface DrawerMenuBackdropProps {
  children: React.ReactNode;
}

const DrawerMenuBackdrop: React.FC<DrawerMenuBackdropProps> = (props) => {
  const { children, ...restProps } = props;

  return (
    <motion.div
      {...restProps}
      exit={{
        opacity: 0,
        transition: {
          duration: OPEN_MENU_ANIMATION_DURATION_OUT,
          ease: OPEN_MENU_ANIMATION_EASE_OUT,
        },
      }}
    >
      {children}
    </motion.div>
  );
};

export default DrawerMenuBackdrop;
